import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91ed2dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row my-2" }
const _hoisted_3 = { class: "col-12 hidden-print" }
const _hoisted_4 = { class: "d-flex flex-row align-items-center" }
const _hoisted_5 = { class: "px-1 d-flex flex-column" }
const _hoisted_6 = { class: "mb-0 ml-1" }
const _hoisted_7 = {
  key: 0,
  class: "d-block mb-0 ml-1 mt-1"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-1 mb-2" }, null, -1))
const _hoisted_9 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_10 = {
  alt: "cadac loyalty discount icon",
  class: "coin-image"
}
const _hoisted_11 = { class: "button-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_13 = {
  alt: "cadac prepaid icon",
  class: "coin-image"
}
const _hoisted_14 = { class: "button-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_16 = {
  alt: "autodesk loyalty cashback icon",
  class: "coin-image"
}
const _hoisted_17 = { class: "button-text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))
const _hoisted_19 = {
  key: 1,
  class: "profile-progress"
}
const _hoisted_20 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_21 = {
  key: 1,
  class: "mb-0 text-info"
}
const _hoisted_22 = {
  key: 2,
  class: "profile-status"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-1 my-lg-3" }, null, -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-3 hidden-print" }
const _hoisted_26 = { class: "col-md-9 col-print-12 pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileImage = _resolveComponent("ProfileImage")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MyCadacBannerBlock = _resolveComponent("MyCadacBannerBlock")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_StatusBadge = _resolveComponent("StatusBadge")!
  const _component_MyCadacMenu = _resolveComponent("MyCadacMenu")!
  const _component_CtaBlockModal = _resolveComponent("CtaBlockModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_ProfileImage, {
                "can-change-image": !!_ctx.expertStore.expertProfile,
                "first-letter-avatar": _ctx.firstLetterAvatar,
                "profile-image-url": _ctx.profileImageUrl,
                onOnProfilePictureChange: _ctx.onProfilePictureChange
              }, null, 8, ["can-change-image", "first-letter-avatar", "profile-image-url", "onOnProfilePictureChange"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.userFullName), 1),
              (_ctx.displayUser?.isEmailVerified)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.displayUser?.company?.companyName), 1))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.displayUser?.company?.walletBalance?.earnedWalletAmount  > 0 || _ctx.displayUser?.company?.usedWalletBalances?.hasUsedEarnedWalletAmount)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "custom-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.openUrl(_ctx.vm.walletOverviewPageUrl)))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                          [_directive_lazy, '/Static/images/loyalty-silver.png']
                        ]),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatCurrency(_ctx.displayUser?.company?.walletBalance?.earnedWalletAmount)), 1),
                        _hoisted_12
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.displayUser?.company?.walletBalance?.depositedWalletAmount > 0 || _ctx.displayUser?.company?.usedWalletBalances?.hasUsedDepositedWalletAmount)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "custom-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (this.openUrl(_ctx.vm.walletOverviewPageUrl)))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                          [_directive_lazy, '/Static/images/loyalty-gold.png']
                        ]),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatCurrency(_ctx.displayUser?.company?.walletBalance?.depositedWalletAmount)), 1),
                        _hoisted_15
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.displayUser?.company?.walletBalance?.autodeskWalletAmount  > 0 || _ctx.displayUser?.company?.usedWalletBalances?.hasUsedLoyaltyCashbackWalletAmount)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      class: "custom-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (this.openUrl(_ctx.vm.walletOverviewPageUrl)))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                          [_directive_lazy, '/Static/images/autodesk-coin.png']
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatCurrency(_ctx.displayUser?.company?.walletBalance?.autodeskWalletAmount)), 1),
                        _hoisted_18
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.isSmallScreen && _ctx.vm.bannerBlock)
              ? (_openBlock(), _createBlock(_component_MyCadacBannerBlock, {
                  key: 0,
                  vm: _ctx.vm.bannerBlock
                }, null, 8, ["vm"]))
              : (_ctx.showProfileProgress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.expertStore.expertProfile?.profileCompletionPercentage === 100)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(_ctx.$t("myCadac.expertSettings.profileComplete")), 1))
                      : (_openBlock(), _createElementBlock("label", _hoisted_21, _toDisplayString(_ctx.$t("myCadac.expertSettings.profileIncomplete")), 1)),
                    _createVNode(_component_ProgressBar, {
                      class: "mb-1",
                      style: {"height":"1.25rem"},
                      value: _ctx.expertStore.expertProfile?.profileCompletionPercentage
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("b", null, _toDisplayString(_ctx.expertStore.expertProfile?.profileCompletionPercentage) + "%", 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    (_ctx.isProfileComplete && _ctx.cta)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 2,
                          class: "flex-shrink-0 p-button-success",
                          icon: "pi pi-check-circle",
                          label: _ctx.$t('myCadac.expertProfile.btnSendProfile'),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expertStore.showModal('SendProfile')))
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.expertStore?.expertProfile && _ctx.expertStore.expertProfile.state)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_StatusBadge, {
                        status: _ctx.expertStore.expertProfile.state,
                        "translation-prefix": "enum.expertPageState",
                        type: 2
                      }, null, 8, ["status"])
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _hoisted_23
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_MyCadacMenu, {
            "menu-items": _ctx.vm.menuItems
          }, null, 8, ["menu-items"])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ])
    ]),
    (_ctx.expertStore.isSendProfileModalVisible)
      ? (_openBlock(), _createBlock(_component_CtaBlockModal, {
          key: 0,
          header: _ctx.$t('myCadac.expertSettings.dialogRequestApprovalHeader'),
          vm: _ctx.cta,
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expertStore.hideModal('SendProfile'))),
          onSubmit: _ctx.onApprovalRequested
        }, null, 8, ["header", "vm", "onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}